/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { Select, Spin } from 'antd';
import { useDispatch } from 'react-redux';
import { searchEmailTemplateUsers } from '../../redux/emailTemplateSlice';

const userLabel = (u) => `${u.name} ${u.surname} <${u.email}>`;

const RecipientSelect = ({ value = [], onChange }) => {
	const dispatch = useDispatch();
	const [options, setOptions] = useState([]);
	const [searching, setSearching] = useState(false);
	const [selected, setSelected] = useState([]);
	const debounceRef = useRef(null);
	const requestIdRef = useRef(0);

	useEffect(() => {
		if (!value?.length) return;
		dispatch(searchEmailTemplateUsers({ search: '', page: 0, size: 100 }))
			.unwrap()
			.then((users) => {
				const resolved = value.map((id) => {
					const found = users.find((u) => u.id === id);
					return found
						? { value: found.id, label: userLabel(found) }
						: { value: id, label: `User #${id}` };
				});
				setSelected(resolved);
				setOptions(users.map((u) => ({ value: u.id, label: userLabel(u) })));
			});
	}, []);

	const handleSearch = (text) => {
		clearTimeout(debounceRef.current);
		setSearching(true);
		setOptions([]);
		requestIdRef.current += 1;
		const reqId = requestIdRef.current;
		debounceRef.current = setTimeout(() => {
			dispatch(searchEmailTemplateUsers({ search: text, page: 0, size: 20 }))
				.unwrap()
				.then((users) => {
					if (reqId !== requestIdRef.current) return;
					setOptions(users.map((u) => ({ value: u.id, label: userLabel(u) })));
				})
				.finally(() => {
					if (reqId === requestIdRef.current) setSearching(false);
				});
		}, 300);
	};

	const handleChange = (items) => {
		setSelected(items);
		if (onChange) onChange(items.map((i) => i.value));
	};

	return (
		<Select
			mode='multiple'
			labelInValue
			value={selected}
			options={options}
			loading={searching}
			showSearch
			filterOption={false}
			onSearch={handleSearch}
			onChange={handleChange}
			onFocus={() => {
				if (!options.length) handleSearch('');
			}}
			notFoundContent={searching ? <Spin size='small' /> : 'No users found'}
			placeholder='Search by name, email or phone...'
			style={{ width: '100%' }}
			maxTagCount='responsive'
		/>
	);
};

export default RecipientSelect;
